<template>
  <div class="mine_right flex_item">
    <div class="mine_rightTop hasTab">
      <div class="flex">
        <span class="mine_line"></span>
        <p class="flex_item">我的课程</p>
      </div>
      <div class="mine_tab flex">
        <a
          href="javascript:;"
          @click="updateSelectedTab('全部培训')"
          class="mine_tabItem"
          :class="tabItemClass('全部培训')"
          >全部培训</a
        >
        <a
          href="javascript:;"
          @click="updateSelectedTab('待培训')"
          class="mine_tabItem"
          :class="tabItemClass('待培训')"
          >待培训</a
        >
        <a
          href="javascript:;"
          @click="updateSelectedTab('培训中')"
          class="mine_tabItem"
          :class="tabItemClass('培训中')"
          >培训中
          <!-- <span class="warn_num">1</span> -->
        </a>
        <a
          href="javascript:;"
          @click="updateSelectedTab('已结业')"
          class="mine_tabItem"
          :class="tabItemClass('已结业')"
          >已结业</a
        >
      </div>
    </div>
    <div class="mine_rightBody hasTab">
      <div class="kc_ul">
        <div
          v-for="(course, index) of courseList"
          :key="index"
          class="kc_li flex"
        >
          <router-link
            :to="{ path: '/coursedetail', query: { id: course.courseId } }"
          >
            <img :src="course.cover" class="kc_tx" alt="" />
          </router-link>
          <div class="kc_body flex_item">
            <div class="flex">
              <span
                class="kc_status"
                :class="statusMsgBgColorClass(course.courseStatus)"
                >{{ course.courseStatus }}</span
              >
              <router-link
                :to="{ path: '/coursedetail', query: { id: course.courseId } }"
                class="kc_name flex_item"
              >
                {{ course.courseName }}
              </router-link>
              <span class="kc_time">{{ course.courseScore }}分</span>
            </div>
            <div class="flex">
              <div class="flex_item">
                <div class="kc_date">
                  {{ course.startTime }} 至 {{ course.endTime }}
                </div>
                <div v-if="course.courseStatus != '待培训'" class="kc_pro">
                  <!-- <p class="kc_proLab">
                    学习到第一讲 新高考改革的趋势与学校应对策略
                  </p> -->
                  <div class="flex">
                    <div class="kc_proBody">
                      <span :style="{ width: `${course.complete}%` }"></span>
                    </div>
                    <span class="kcjd">已学习{{ course.complete }}%</span>
                  </div>
                </div>
                <div
                  v-if="course.courseStatus == '待培训'"
                  class="kc_pro_space"
                ></div>
              </div>
              <button
                v-if="course.courseType == '在线课程'"
                class="kc_btn"
                @click="courseButtonAction(course)"
              >
                {{ courseButtonTitle(course) }}
              </button>
              <button
                v-if="course.courseType == '线下课程'"
                class="kc_btn"
                @click="courseButtonAction(course)"
              >
                签到情况
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="courseList.length == 0">
        <div class="listNullTip">
          <img src="../../assets/icon_empty.png" />
          <span>暂无数据</span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showLearningLayer">
    <MineLearningLayer
      @closeLayer="showLearningLayer = false"
      @writeImpression="writeImpression"
      :learningInfo="this.learningInfo"
    />
  </div>
  <div v-if="showSignningLayer">
    <MineSignningLayer
      @closeLayer="showSignningLayer = false"
      @writeImpression="writeImpression"
      :signInfo="this.signningInfo"
    />
  </div>
  <div v-if="showImpressionLayer">
    <MineImpressionLayer
      @closeLayer="showImpressionLayer = false"
      @closeLayerFromImpression="writeImpressionSuccess"
      :courseId="this.writeImpressionId"
    />
  </div>
</template>

<script>
import { getUserCourseList } from "../../server/user_center_course";
import { getCourseLearningRecord, getUserOfflineSign } from "../../server/user_center_learning";
// 学习情况浮层
import MineLearningLayer from "./MineLearning";
// 签到情况浮层
import MineSignningLayer from "./MineSignning";
// 学习感悟浮层
import MineImpressionLayer from "./MineImpression";

export default {
  components: {
    MineLearningLayer,
    MineSignningLayer,
    MineImpressionLayer,
  },
  data() {
    return {
      courseList: [],
      selectedTab: "全部培训",
      // 是否显示浮层
      showLearningLayer: false,
      showSignningLayer: false,
      showImpressionLayer: false,
      // 写感悟时提交的课程id
      writeImpressionId: 0,
      // 学习情况信息
      learningInfo: {
        courseId: 0,
        infos: [],
      },
      // 签到情况信息
      signningInfo: {
        duration: 0,
        infos: [],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted() {
    this.fetchUserCourseList();
  },
  methods: {
    async fetchUserCourseList() {
      let params = {};
      switch (this.selectedTab) {
        case "待培训":
          params.courseStatus = 301;
          break;
        case "培训中":
          params.courseStatus = 302;
          break;
        case "已结业":
          params.courseStatus = 304;
          break;
        default:
          break;
      }
      let result = await getUserCourseList(params);
      this.courseList = result;
    },
    tabItemClass(tab) {
      return this.selectedTab == tab ? "active" : "";
    },
    updateSelectedTab(tab) {
      this.selectedTab = tab;
      this.fetchUserCourseList();
    },
    statusMsgBgColorClass(status) {
      let cls = "";
      // back_green: 培训中;
      // back_org_1: 待培训;
      // back_blue: 已结业;
      switch (status) {
        case "培训中":
          cls = "back_green";
          break;

        case "待培训":
          cls = "back_org_1";
          break;

        case "已结业":
          cls = "back_blue";
          break;

        default:
          cls = "back_green";
          break;
      }
      return cls;
    },
    courseButtonTitle(course) {
      let title = "未开始";
      switch (course.courseStatus) {
        case "培训中":
          title = "继续学习";
          break;

        case "待培训":
          title = "未开始";
          break;

        case "已结业":
          title = "学习情况";
          break;

        default:
          title = "未开始";
          break;
      }
      if (course.complete == 100 && !course.completeFeeling) {
        title = "写感悟";
      }
      return title;
    },
    goToCourseDetail(course) {
      this.$router.push({
        name: "CourseDetail",
        query: { id: course.courseId },
      });
    },
    courseButtonAction(course) {
      if (course.courseType == "线下课程") {
        // 展示签到情况
        this.showOfflineSignResult(course.courseId);
      } else {
        if (course.courseStatus == "培训中") {
          if (course.complete != 100) {
            // 继续学习
            this.goToCourseDetail(course);
            return;
          } else {
            if (!course.completeFeeling) {
              // 写感悟
              this.writeImpression(course.courseId);
              return;
            }
            if (!course.completeVideo) {
              // 继续学习
              this.goToCourseDetail(course);
              return;
            }
          }
        } else if (course.courseStatus == "已结业") {
          // 展示学习情况
          this.showLearningResult(course.courseId);
        }
      }
    },
    writeImpression(courseId) {
      // 隐藏掉可能存在的学习情况浮层
      this.showLearningLayer = false;
      this.showSignningLayer = false;
      // 显示写感悟浮层
      this.writeImpressionId = courseId;
      this.showImpressionLayer = true;
    },
    //展示学习情况
    async showLearningResult(courseId) {
      let result = await getCourseLearningRecord(courseId);
      if (result != false) {
        this.learningInfo.courseId = courseId;
        this.learningInfo.infos = result;
        this.showLearningLayer = true;
      }
    },
    //展示签到情况
    async showOfflineSignResult(courseId) {
      let xxqkQuery = {
        userId: this.userInfo.userId,
        courseId: courseId,
      };
      let result = await getUserOfflineSign(xxqkQuery);
      if (result != false) {
        this.showSignningLayer = true;
        this.signningInfo.duration = result.signinDuration;
        this.signningInfo.infos = result.userSigninInfoList;
      }
    },
    writeImpressionSuccess() {
      this.showImpressionLayer = false;
      this.fetchUserCourseList();
    },
  },
};
</script>

<style scoped>
.mine_right {
  box-sizing: border-box;
  margin-top: 16px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.mine_rightTop {
  padding: 24px 32px;
  border-bottom: 1px solid #f3f3f3;
  background-color: #fff;
}

.mine_rightTop p {
  font-size: 28px;
  font-weight: 600;
  color: #222;
}

.mine_rightTop.hasTab {
  border-bottom: 0px;
  padding-bottom: 0px;
}

.mine_rightBody.hasTab {
  background-color: #f9f9f9;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
}

.mine_tab {
  margin-top: 40px;
}

.back_org_1 {
  background-color: #ff8a15;
}

.back_org_2 {
  background-color: #ff6100;
}

.back_blue {
  background-color: #003399;
}

.back_green {
  background-color: #26ad8f;
}

.mine_line {
  width: 5px;
  height: 28px;
  background-color: #003399;
  border-radius: 3px;
  margin-right: 20px;
}

.mine_tabItem {
  margin-right: 60px;
  font-size: 16px;
  color: #666;
  line-height: 22px;
  padding-bottom: 30px;
  font-weight: 500;
  position: relative;
}

.mine_tabItem.active {
  color: #222;
  font-weight: bold;
}

.mine_tabItem.active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  width: 36px;
  margin-left: -18px;
  height: 2px;
  background-color: #003399;
}

.warn_num {
  position: absolute;
  top: -8px;
  right: -15px;
  width: 15px;
  height: 15px;
  background-color: #ff4343;
  color: #fff;
  text-align: center;
  line-height: 15px;
  font-size: 12px;
  border-radius: 50%;
}

.kc_li {
  margin-top: 16px;
  padding: 24px;
  background-color: #fff;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.kc_tx {
  width: 176px;
  height: 120px;
  margin-right: 20px;
}

.kc_status {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  padding: 2px 8px;
  border-radius: 2px;
  margin-right: 12px;
}

.kc_name {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
  margin-right: 20px;
}

.kc_name:hover {
  color: #ff6100;
}

.kc_time {
  font-size: 14px;
  font-weight: 400;
  color: #666;
}

.kc_date {
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
  line-height: 20px;
}

.kc_pro {
  margin-top: 28px;
}

.kc_pro_space {
  margin-top: 28px;
  height: 20px;
}

.kc_proLab {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  line-height: 20px;
}

.kc_proBody {
  position: relative;
  width: 438px;
  height: 6px;
  border-radius: 5px;
  background-color: #f0f1f4;
  margin-right: 16px;
  overflow: hidden;
}

.kc_proBody span {
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 6px;
  background-color: #26ad8f;
}

.kcjd {
  color: #26ad8f;
  font-size: 14px;
}

.kc_btn {
  font-size: 14px;
  color: #003399;
  background-color: white;
  font-weight: 400;
  width: 90px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border: 1px solid #003399;
  border-radius: 4px;
  margin-top: 0px;
  cursor: pointer;
}
.listNullTip {
  width: 100%;
  padding-top: 126px;
}

.listNullTip img {
  display: block;
  margin: 0 auto;
  width: 240px;
  margin-bottom: 9px;
}

.listNullTip span {
  display: block;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
}
</style>